const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export async function track(event_type: string, event_data?: Record<string, unknown>): Promise<void> {
  try {
    await fetch(`${BASE}/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type, event_data }),
      keepalive: true,
    });
  } catch { /* never fail */ }
}

export async function logError(
  error_type: string,
  error_message: string,
  details?: unknown
): Promise<void> {
  try {
    await fetch(`${BASE}/log-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ error_type, error_message, details }),
      keepalive: true,
    });
  } catch { /* never fail */ }
}
